function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var LogoEColorBrandSvg = function LogoEColorBrandSvg(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 120 120"
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    x1: "7.797%",
    y1: "95.373%",
    x2: "95.085%",
    y2: "1.517%",
    id: "logo-e-color-brand_svg__a"
  }, React.createElement("stop", {
    stopColor: "#F6682F",
    offset: "0%"
  }), React.createElement("stop", {
    stopColor: "#FFB91E",
    offset: "100%"
  }))), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("circle", {
    fill: "url(#logo-e-color-brand_svg__a)",
    cx: 59,
    cy: 59,
    r: 59
  }), React.createElement("path", {
    d: "M54.384 39.263c8.401-1.862 16.785 1.513 21.453 7.897l-37.131 8.232c1.281-7.703 7.276-14.266 15.678-16.129zm21.66 30.286c-2.807 3.995-7.135 7.018-12.411 8.188-8.457 1.875-16.895-1.559-21.545-8.024l37.246-8.258 6.067-1.345L97 57.538a35.32 35.32 0 0 0-.966-7.247C91.313 30.654 70.909 18.41 50.46 22.943 30.011 27.477 17.261 47.072 21.982 66.71c4.722 19.637 25.126 31.881 45.574 27.348 12.05-2.672 21.422-10.573 26.125-20.63L76.044 69.55z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
};

LogoEColorBrandSvg.displayName = "LogoEColorBrandSvg";
export default LogoEColorBrandSvg;